var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScorpioSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "-20 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 1.1400000000000001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.72 149.24L131.17 175.63L127.09 165.91C123.27 168.66 118.09 170.51 110.94 170.51C96.34 170.51 88.94 161.32 88.94 139.69C88.94 128.41 89.25 112.01 89.25 101.29C89.25 85.0403 87.33 79.0603 80.32 79.0603C74.64 79.0603 73.08 82.1503 72.13 88.8903C72.2567 90.7769 72.3233 92.7769 72.33 94.8903C72.33 101.51 72.33 147.42 72.33 147.42L55.57 147.24C55.57 147.24 55.57 110.41 55.57 101.24C55.57 84.9903 54.5 79.0103 46.64 79.0103C40.64 79.0103 39.23 82.4803 38.29 90.0103L38.76 147L22.27 147.85L22.18 76.7003L21.06 65.5303L35.37 63.5303L36.85 69.6603C40.05 66.0903 44.92 63.5303 52.55 63.5303C59.6 63.5303 64.98 66.3003 68.34 72.7603C71.42 67.6403 76.71 63.5303 86.17 63.5303C99.11 63.5303 105.96 71.2603 105.96 94.9403C105.96 117.72 105.76 140.62 105.76 140.62C106.17 150.97 107.76 156.13 116.04 156.13C118.231 156.127 120.378 155.514 122.24 154.36L118 144.22L147.72 149.24Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScorpioSvgrepoCom);
export default __webpack_public_path__ + "static/media/scorpio-svgrepo-com.f9db9e4d609da34253a31d3df0700a11.svg";
export { ForwardRef as ReactComponent };